import React from 'react';
import { Box, Typography } from '@mui/material';
import { DrawerBoxComponent } from '../DrawerBoxComponent/DrawerBoxComponent';
import StatusIcon from '@mui/icons-material/FiberManualRecord';
import SecondaryBtnComponent from '../buttonComponent/SecondaryBtnComponent';
import { APPOINTMENTS } from '../../shared/Strings';

export const AppointmentVisitDetailsSummary = ({
  visitDescription,
  visitReason,
  handleBackInStepper,
  showEditButton,
}) => {
  return (
    <DrawerBoxComponent>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          pr: 2,
        }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            pr: 2,
          }}>
          <Typography variant="navSelected" sx={{ pr: 2 }}>
            {APPOINTMENTS.VISIT_DETAIL}
          </Typography>
          <Typography variant="h5" display="inline">
            {visitDescription}
          </Typography>
          <Typography variant="h5" display="inline">
            <StatusIcon
              htmlColor="black"
              sx={{
                height: 10,
                width: 10,
                mr: 0.5,
                ml: 2,
              }}
            />
            {visitReason}
          </Typography>
        </Box>
        {showEditButton ? (
          <SecondaryBtnComponent
            onClick={handleBackInStepper}
            title={APPOINTMENTS.EDIT}
          />
        ) : null}
      </Box>
    </DrawerBoxComponent>
  );
};
